// 教科の型定義
export type SubjectType =
  | '国語'
  | '算数'
  | '数学'
  | '理科'
  | '社会'
  | '英語'
  | '技術・家庭'
  | '情報'
  | '音楽'
  | '美術'
  | '保健体育'
  | '総合的な学習'
  | '道徳'
  | 'その他';

// 教科の選択肢（管理画面用）
export const SUBJECT_OPTIONS: { value: SubjectType; label: string }[] = [
  { value: '国語', label: '国語' },
  { value: '算数', label: '算数' },
  { value: '数学', label: '数学' },
  { value: '理科', label: '理科' },
  { value: '社会', label: '社会' },
  { value: '英語', label: '英語' },
  { value: '技術・家庭', label: '技術・家庭' },
  { value: '情報', label: '情報' },
  { value: '音楽', label: '音楽' },
  { value: '美術', label: '美術' },
  { value: '保健体育', label: '保健体育' },
  { value: '総合的な学習', label: '総合的な学習' },
  { value: '道徳', label: '道徳' },
  { value: 'その他', label: 'その他' },
];

// 教科フィルター用の選択肢（「全ての教科」を含む）
export const SUBJECT_FILTER_OPTIONS = [
  { value: 'all', label: '全ての教科' },
  ...SUBJECT_OPTIONS,
];

// 教科が有効かどうかをチェック
export function isValidSubject(subject: string): subject is SubjectType {
  return SUBJECT_OPTIONS.some((option) => option.value === subject);
}

// 未知の教科を安全に表示
export function getSubjectLabel(subject: string): string {
  const option = SUBJECT_OPTIONS.find((opt) => opt.value === subject);
  return option ? option.label : subject;
}

// 教科別のアイコン・色設定（Cookpad風の彩り）
export const SUBJECT_ICON_MAP: Record<SubjectType, { label: string; emoji: string; bgClass: string; textClass: string }> = {
  '国語': { label: '国語', emoji: '📖', bgClass: 'bg-red-50', textClass: 'text-red-600' },
  '算数': { label: '算数', emoji: '🔢', bgClass: 'bg-blue-50', textClass: 'text-blue-600' },
  '数学': { label: '数学', emoji: '📐', bgClass: 'bg-indigo-50', textClass: 'text-indigo-600' },
  '理科': { label: '理科', emoji: '🧪', bgClass: 'bg-green-50', textClass: 'text-green-600' },
  '社会': { label: '社会', emoji: '🌏', bgClass: 'bg-yellow-50', textClass: 'text-yellow-700' },
  '英語': { label: '英語', emoji: '💬', bgClass: 'bg-sky-50', textClass: 'text-sky-600' },
  '技術・家庭': { label: '技術・家庭', emoji: '🔧', bgClass: 'bg-orange-50', textClass: 'text-orange-600' },
  '情報': { label: '情報', emoji: '💻', bgClass: 'bg-purple-50', textClass: 'text-purple-600' },
  '音楽': { label: '音楽', emoji: '🎵', bgClass: 'bg-pink-50', textClass: 'text-pink-600' },
  '美術': { label: '美術', emoji: '🎨', bgClass: 'bg-rose-50', textClass: 'text-rose-600' },
  '保健体育': { label: '保健体育', emoji: '⚽', bgClass: 'bg-emerald-50', textClass: 'text-emerald-600' },
  '総合的な学習': { label: '総合的な学習', emoji: '🌱', bgClass: 'bg-lime-50', textClass: 'text-lime-700' },
  '道徳': { label: '道徳', emoji: '💝', bgClass: 'bg-fuchsia-50', textClass: 'text-fuchsia-600' },
  'その他': { label: 'その他', emoji: '📚', bgClass: 'bg-slate-50', textClass: 'text-slate-600' },
};

// 学年を表示用ラベルに変換
export function getGradeLabel(gradeNumber: number): string {
  if (gradeNumber >= 1 && gradeNumber <= 6) {
    return `小${gradeNumber}`;
  } else if (gradeNumber >= 7 && gradeNumber <= 9) {
    return `中${gradeNumber - 6}`;
  } else if (gradeNumber >= 10 && gradeNumber <= 12) {
    return `高${gradeNumber - 9}`;
  } else {
    return `学年${gradeNumber}`;
  }
}

// 学年範囲を表示用ラベルに変換
export function getGradeRangeLabel(min: number, max: number): string {
  if (min === max) {
    return getGradeLabel(min);
  }
  return `${getGradeLabel(min)}〜${getGradeLabel(max)}`;
}
